var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"main",attrs:{"fluid":"","fill-height":""}},[_c('category-expansion-panel',{on:{"error":_vm.errorPropagation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }